import styled from 'styled-components';
import { Form } from 'antd';

export const FormCustom = styled(Form)`
  border-radius: 10px;
`;
